import React from "react";

interface SendIconProps {
  size?: number;
  className?: string;
}

export default function SendIcon({ size = 24, className = "" }: SendIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.1964 13.0583L15.6268 8.76717C16.8763 5.01852 17.5011 3.14419 16.5117 2.15479C15.5223 1.16541 13.648 1.79019 9.89935 3.03974L5.60824 4.4701C2.5827 5.47861 1.06995 5.98287 0.640062 6.72232C0.231104 7.42577 0.231104 8.29458 0.640062 8.998C1.06995 9.7375 2.5827 10.2418 5.60824 11.2503C5.98319 11.3753 6.40502 11.286 6.6858 11.0078L11.2738 6.46229C11.5319 6.20657 11.9485 6.20851 12.2042 6.46663C12.4599 6.72474 12.458 7.14129 12.1998 7.39702L7.68593 11.8692C7.37651 12.1758 7.27851 12.645 7.41626 13.0583C8.42476 16.0838 8.92901 17.5966 9.66851 18.0264C10.3719 18.4354 11.2408 18.4354 11.9442 18.0264C12.6837 17.5966 13.1879 16.0838 14.1964 13.0583Z"
        fill="currentColor"
      />
    </svg>
  );
}
